import { OrderFilterValues } from 'order/interfaces/OrderFilterValues';
import { FC, useState } from 'react';
import { Checkbox } from 'shared/components/Checkbox';
import { Wrapper } from 'shared/components/Wrapper';
import { DealerTabsEnum } from 'shared/enum/DealerTabsEnum';
import { Spacer } from 'shared/components/Layout';
import styled from 'styled-components';
import { TableTabsEnums } from 'order/enums/orderTableEnums';
import { TabProps, StyledTabs } from 'shared/components/StyledTabs';
import { OrdersTable, OrdersTableProps } from './OrdersTable';

enum Tabs {
  General = 1,
  Timeline,
  Metrics,
}

const CheckboxWrapper = styled(Wrapper)`
  padding: 12px 23px;
  position: absolute;
  top: 0;
  right: 0;
`;

type DealerOrdersTableProps = Pick<
  OrdersTableProps,
  'isLoading' | 'setSearch' | 'search' | 'isQuoteBoard'
>;

export const DealerOrdersTable: FC<DealerOrdersTableProps> = ({
  isLoading,
  setSearch,
  search,
  isQuoteBoard,
}: DealerOrdersTableProps) => {
  const [selectedTab, setSelectedTab] = useState(TableTabsEnums.GENERAL);

  const tabs: TabProps[] = Object.keys(Tabs)
    .filter((k) => Number.isNaN(+k))
    .map((key) => {
      return {
        text: key,
        active: selectedTab === key,
        onClick: () => setSelectedTab(key as TableTabsEnums),
      };
    });

  const onCollaboratingOnChangeHandler = () => {
    setSearch({
      ...(search as OrderFilterValues),
      collaboratingOn: !(search as OrderFilterValues).collaboratingOn,
      page: 1,
    });
  };

  const onShowCancelledOrdersChangeHandler = () => {
    setSearch({
      ...(search as OrderFilterValues),
      showCancelledOrders: !(search as OrderFilterValues).showCancelledOrders,
      page: 1,
    });
  };

  const onShowNewCollaborationChangeHandler = () => {
    setSearch({
      ...(search as OrderFilterValues),
      showNewCollaboration: !(search as OrderFilterValues).showNewCollaboration,
      page: 1,
    });
  };

  return (
    <Wrapper position="relative">
      <CheckboxWrapper flex middle>
        {(search as OrderFilterValues).tab ===
          DealerTabsEnum['Not Submitted'] &&
          !isQuoteBoard && (
            <Checkbox
              title="Hide Cancelled orders"
              id="showCancelledOrders"
              checked={
                (search as OrderFilterValues).showCancelledOrders ?? false
              }
              onChange={onShowCancelledOrdersChangeHandler}
            />
          )}

        <>
          <Spacer w="32px" />

          <Checkbox
            title="New collaboration"
            id="showNewCollaboration"
            checked={
              (search as OrderFilterValues).showNewCollaboration ?? false
            }
            onChange={onShowNewCollaborationChangeHandler}
          />
        </>

        <Spacer w="32px" />

        <Checkbox
          title="Collaborating on"
          id="collaboratingOn"
          checked={(search as OrderFilterValues).collaboratingOn ?? false}
          onChange={onCollaboratingOnChangeHandler}
        />
      </CheckboxWrapper>

      <StyledTabs tabs={tabs} nounderline={1} />

      <OrdersTable
        tab={selectedTab}
        isLoading={isLoading}
        setSearch={setSearch}
        search={search}
        isQuoteBoard={isQuoteBoard}
      />
    </Wrapper>
  );
};
